const Form072TC = {
    stepName: {
        importantNotes: "背景",
        formType: "表格類型",
        notificationForm: "表單",
        confirmation: "確認頁面",
        sign: "簽署",
    },
    conditionLabel: {
        termsConditions: "我已閱讀條款",
        header1: "標題",
        header2: "條件",
    },
    noteTitle: {
        title1: "摘要",
        title2: "詳情",
        title3: "可再生能源設施",
        title4: "參加「上網電價」計劃",
        title5: "會計安排",
        title6: "查詢",
    },
    noteList: {
        note1: "按教育局通函第168/2019號「學校參加『上網電價』計劃」，所有學校向電力公司提交參加「上網電價」計劃的申請時，須同時向教育局提交通函所夾附的通知表格，以作記錄。在獲知申請結果後，學校亦須盡快將電力公司發出的批准函或拒絕信件副本送交教育局，以供存檔。詳情請參閱以下連結的教育局通函﹕",
        // note1: "本通函旨在通知學校參加「上網電價」計劃時須留意的事項。由2019/20學年起本通函取代2018年8月20日的教育局通函第113/2018號。本函應與教育局通告第4/2017號「學校的環保政策及節約能源措施」一併閱讀，以配合學校的環保政策及環保教育。",
        note1a: "https://applications.edb.gov.hk/circular/upload/EDBCM/EDBCM19168C.pdf",
        // note1a: "學校參加「上網電價」計劃的安排不適用於官立學校。",
        note2: "有關提交電子表格的查詢，請與支持熱線聯絡。",
        // note2: "2. 香港政府與兩間電力公司（即中華電力有限公司及香港電燈有限公司）於2017年4月簽訂新的《管制計劃協議》（《協議》）。考慮了市民的意見及為應對氣候變化，新《協議》引入多項措施，鼓勵電力公司自行發展可再生能源，並同時促進可再生能源的發展。當中，引入「上網電價」計劃是新《協議》中推廣可再生能源的一項重要措施。「上網電價」計劃由兩間電力公司推行，鼓勵私營機構及社區發展可再生能源，然後以高於一般電費水平的價格，把所生產的電力售予電力公司。",
        note3: "3. 為配合政府的環保政策，環境局與教育局鼓勵學校在不妨礙學生活動及安全的情況下在校舍內安裝可再生能源系統。中、小學及幼稚園",
        note3a: "亦可因應學校的情況，參加「上網電價」計劃。我們希望學校在參與計劃時，能善用已安裝的可再生能源系統，推動校內的環保教育。學校在安裝可再生能源設施及參加「上網電價」計劃時，須留意以下各項：",
        note4N: "(i)",
        note4: "所有學校可以申請適用的政府資助（如環境及自然保育基金和「採電學社：學校及非政府福利機構太陽能支援計劃」",
        note4a: "）或運用捐贈及贊助等，購買、租用、安裝、更換或維修保養可再生能源設施，以及支付相關設施的其他經常費用（如有）。此外，資助學校及按位津貼學校可以使用普通經費帳內的經費來支付有關費用。不過，收取學費的學校",
        note4b: "不可直接運用學費收入作相關用途；而接受政府經常性資助的學校",
        note4c: "，亦不可透過任何借貸安排（包括但不限於分期付款）或教育局的資助（包括緊急修葺工程及年度大規模修葺工程）來購買、租用、安裝、更換或維修保養",
        note4d: "可再生能源設施，以及支付相關設施的其他經常費用（如有）。",
        note5N: "(ii)",
        note5: "所有學校安裝可再生能源設施，如涉及任何結構上的改動，應按現行規定向教育局提交申請，並須事先獲得批准",
        note5a: "。",
        note6N: "(iii)",
        note6: "在購買、租用、安裝、更換或維修保養可再生能源設施時，所有學校應參照本局現行的通告和指引",
        note6a: "，在公開和公平的原則下，定期進行具競爭性的招標／報價程序甄選供應商／承辦商。所有學校不應索取或接受供應商／承辦商的捐贈或任何形式的利益。",
        note7N: "(iv)",
        note7: "所有學校應善用已安裝的可再生能源系統，透過學校的教學活動",
        note7a: "或課餘活動，增進學生的環保知識。",
        note8N: "(v)",
        note8: "學校參加「上網電價」計劃屬商業活動，資助學校、按位津貼學校、直資學校及英基學校須遵照本局通告第10/2016號「學校的商業活動」的相關規定",
        note8a: "，未設有法團校董會的學校必須事先得到教育局常任秘書長書面准許。請注意，一般商業活動的利潤上限並不適用於「上網電價」計劃。接受政府經常性資助的學校",
        note8b: "及屬於非牟利的私立學校和幼稚園須將有關收入應用於直接讓學生受惠的用途，例如舉辦促進環境保護的教育活動及購買、租用或維修保養可再生能源設施。",
        note9N: "(vi)",
        note9: "所有學校參加「上網電價」計劃均須由校董會／法團校董會批准。",
        note10N: "(vii)",
        note10: "所有學校不可租借校舍，以讓第三方參加「上網電價」計劃。接受政府經常性資助的學校",
        note10a:
            "及屬於非牟利的私立學校和幼稚園不可透過向第三方分派收入的方式與他人合作，以參加「上網電價」計劃。",
        note11N: "(viii)",
        note11: "所有學校須留意接駁電網安排，以及與安裝可再生能源發電系統有關的法例。",
        note12N: "(ix)",
        note12: "所有學校向電力公司提交參加「上網電價」計劃的申請時，須同時向教育局提交本通函所夾附的通知表格，以作記錄。在獲知申請結果後，學校亦須盡快把電力公司發出的批准函或拒絕信件傳真至本局學校行政第四組（副本送交學校所屬高級學校發展主任/高級服務主任），以供存檔。",
        note13N: "(x)",
        note13: "所有學校須為「上網電價」的收入與相關支出備存一個獨立帳目。學校須保存收支記錄及相關的收據／發票，以供本局有需要時查核。",
        note14N: "(xi)",
        note14: "各類學校須按教育局要求，將「上網電價」獨立帳目內的收入與相關支出，反映於經審核帳目內",
        note14a:
            "。資助學校及按位津貼學校應將收支填報在普通經費帳，以反映「上網電價」項目的收支；而直資學校和參加幼稚園教育計劃的幼稚園",
        note14b:
            "，以及須按本局既定格式製備經審核帳目的私立學校及英基學校協會轄下與教育局簽訂服務合約的學校，則應將收支填報在經審核帳目內的報表／附註中，以反映「上網電價」項目的收支；至於不須按本局既定格式製備經審核帳目的私立學校及英基學校協會轄下的其餘學校，應按既定的會計準則將有關收支反映於經審核帳目／財務報告內。",
        note15N: "(xii)",
        note15: "各類學校應以「上網電價」的相關收入或參照上文第3(i) 段，使用合適的資金，支付所需的開支（例如接駁電網的費用及維修保養可再生能源設施的支出）或任何虧損。",
        note16N: "(xiii)",
        note16: "資助學校及按位津貼學校應將「上網電價」的收入盈餘（如有的話）記入普通經費帳，而收取學費的學校",
        note16a:
            "則可將盈餘於非政府經費帳／學校經費帳累積，以支付可再生能源設施日後的維修保養開支和用於直接讓學生受惠的用途。請注意，所有學校應就參加「上網電價」計劃製備現金流的預算，並保留足夠的餘款，以應付未來可能出現的開支或任何虧損。在購買或租用可再生能源設施時，學校應審慎評估「上網電價」的收入／盈餘是否足夠支付任何服務合約的所需開支，並小心謹慎地訂立相關服務合約的條款（如合約總金額、合約期及付款模式等）。接受政府經常性資助的學校",
        note16b:
            "及屬於非牟利的私立學校和幼稚園不得以任何形式把「上網電價」計劃所產生的收入分派、捐贈或貸款給第三者或調往其他帳項。",
        note17N: "(xiv)",
        note17: "收取學費的學校",
        note17a:
            "不可藉參加「上網電價」為理由而增加學費，相關開支亦不會納入學費調整申請的評估之內。",
        note18: "4. 本局透過通告第4/2017號「學校的環保政策及節約能源措施」，促請所有學校制訂並推行校本環保政策，有關環保政策須獲校董會／法團校董會批准，並期望學校能定期在校董會／法團校董會會議上匯報，以達到不斷檢視和持續發展的目的。如學校參加「上網電價」計劃，可配合校本環保政策，推動可再生能源發展。我們促請學校積極向社區及持份者展示推行校本環保政策的成果，例如於學校網頁分享學校參加「上網電價」計劃、舉辦相關的環境保護教育活動詳情及成效，進一步推廣環保教育。",
        note19: "5. 就參加「上網電價」計劃的查詢，請與下列有關機構／人員聯絡：",
        note20: "教育局局長",
        note21: "劉玉蓮代行",
        note22: "二零一九年九月二日",
        tableTile: "查詢內容",
        tableTile2: "查詢途徑",
        tableLeft: "電力公司的「上網電價」計劃詳情",
        tableLeft2: "安裝可再生能源設施的技術問題",
        tableLeft3: "學校參加「上網電價」的安排",
        tableLeft4: "其他查詢（例如涉及任何結構改動的工程）",
        tableRight: "中華電力有限公司",
        tableRight2: "電話：2678 0322",
        tableRight3: "電郵地址：",
        tableRight4: "csd@clp.com.hk",
        tableRight5: "香港電燈有限公司",
        tableRight6: "電話：2510 2701",
        tableRight7: "RE@hkelectric.com",
        tableRight8: "機電工程署",
        tableRight9: "「香港可再生能源網」的「上網電價」專頁：",
        tableRight10: "http://re.emsd.gov.hk/eindex.html",
        tableRight11: "熱線電話：6395 2930",
        tableRight12: "eepublic@emsd.gov.hk",
        tableRight13: "教育局學校行政第四組",
        tableRight14: "電話：3509 7459",
        tableRight15:
            "所屬的教育局分區高級學校發展主任或幼稚園及幼兒中心聯合辦事處高級服務主任",
    },
    noteTips: {
        tips1: "包括幼稚園、幼稚園暨幼兒中心及設有幼稚園班級的學校。",
        tips2: "學校可透過有關連結參閱兩項計劃的詳請（包括申請資格、計劃範疇等）：環境自然保育基金（https://eeca.ecc.org.hk/uploadfiles/tc/EECA_Guide%20to%20Application_TC(Mar2019).pdf）採電學社（https://re.emsd.gov.hk/tc_chi/gen/4S/4S.html）",
        tips3: "包括直資學校、英基學校、私立學校和幼稚園。",
        tips4: "包括資助學校、按位津貼學校、直資學校、英基學校，以及參加幼稚園教育計劃的幼稚園和曾參加學前教育學券計劃或幼稚園教育計劃，但仍有部份學生獲有關計劃資助的幼稚園。",
        tips5: "就維修保養可再生能源設施，設有法團校董會的資助學校，亦可使用擴大的營辦開支整筆津貼的餘款，來補貼不超過(i)政府資助計劃的經常開支的50%；以及(ii)透過私人捐贈或其他籌款計劃而得到的家具、設備和其他設施或教育服務的經常開支的25 %。",
        tips6: "《教育規例》(第279A章)第10(a)條訂明，除經常任秘書長以書面同意外，不得對校舍作任何結構上的改動。",
        tips7: "資助學校、按位津貼學校及直資學校應參照本局通告第4/2013號「資助學校採購程序」；其他學校須合符教育局通告第14/2003號「學校及其教職員收受利益和捐贈事宜」內相關要求。就有關合約期的安排，所有學校應參照本局通告第10/2016號「學校的商業活動」附錄4「在公帑資助學校內以高於標準的設施經營業務／商業活動的基本指導原則」的第(i)項，以及政府效率促進辦公室的「合約管理用者指引」（https://www.effo.gov.hk/tc/reference/publications/cm2007_tc.pdf）第6.3段辦理。",
        tips8: "如學校有關的可再生能源設施設置於天台，而學校有意在天台進行教學活動，應參閱《教育規例》第16至20條就天台操場的規定。",
        tips9: "私立學校應遵從本局通告第17/2003號「在私立學校售賣教育用品及提供收費服務的指引」；而幼稚園須同時遵從本局通告第16/2013號「幼稚園收取費用、售賣教育用品及提供收費服務」的相關規定。",
        tips10: "資助學校、按位津貼學校、直資學校和參加幼稚園教育計劃的幼稚園，以及須按本局既定格式製備經審核帳目的私立學校及英基學校協會轄下與教育局簽訂服務合約的學校，須將「上網電價」獨立帳目內的收入與相關支出，反映在2018/19年度及往後的經審核帳目內。本局會另行通知各類學校有關擬備經審核帳目的詳情。",
        tips11: "包括曾參加學前教育學券計劃或幼稚園教育計劃，但仍有部份學生獲有關計劃資助的幼稚園。",
    },
    importantNotesHeader: "背景",
    importantNotesContent:
        "本校會於接獲電力公司告知申請結果後，把電力公司發出的批准信或拒絕信提交至教育局學校行政第四組（副本送交學校所屬分區高級學校發展主任/高級服務主任），以作記錄。本校亦知悉，如安裝可再生能源設施涉及校舍任何結構上的改動，本校會按現行規定向教育局提交申請，並須事先獲得批准才進行可再生能源設施的安裝工程。",
    titleOption: {
        Mr: "先生",
        Mrs: "太太",
        Miss: "小姐",
        Ms: "女士",
        Others: "其他",
    },
    schoolHeadOption: {
        supervisor: "校監",
        head: "校長",
    },
    formLabel: {
        companies: {
            CLP: "中華電力有限公司",
            electricCompany: "香港電燈有限公司",
        },
        schoolName: "學校名稱",
        or: "或",
        date: "日期",
        header: "學校參加「上網電價」計劃通知表格",
        headerY: "（",
        headerN: "（不",
        headerLastText: "連同電力公司的批准信或拒絕信）",
        formType: "選擇需要提交的資料",
        notificationForm: "填寫通知表格/提交電力公司信件",
        // attachment: "附件",
        attachment: "上傳電力公司的批准信或拒絕信",
        attachmentRemarkHaveLetter:
            "[註：如貴校並未曾收到相關批准或拒絕信件，請在底部點擊「返回」，以及在「第二步」選擇「提交通知表格（不連同電力公司的批准信或拒絕信）」。]",
        attachmentRemarkUploadLetter:
            "[註：如貴校並未曾向教育局提交『學校參加「上網電價」計劃通知表格』，請在底部點擊「返回」，以及在「第二步」選擇「提交通知表格（連同電力公司的批准信或拒絕信）」。]",
        schoolHead: "請選擇校監／校長",

        schoolHeadTitle: "（稱謂：",
        afterSchoolHeadTitle: "）",
        schoolHeadName: "姓名",
        schoolHeadSign: "簽署：",
        contactNameTitle: "（稱謂：",
        contactName: "聯絡人姓名",
        labelbeforeDistrict: "本通知應送抄：",
        labelAfterDistrict: "（所屬分區）高級學校發展主任 /高級服務主任，即",
        district: "所屬分區",
        completedBySchool: "此欄由學校填寫",
        otherContactNameTitle: "稱謂",
        ssdoLabel: "高級學校發展主任",
    },
    signHeader: "簽署",
    formContent: {
        componyRadioBeforeText: "本校決定申請參加",
        componyRadioAfterText: "",
        dateBeforeText: "推出的「上網電價」計劃，並已於",
        dateAfterText: "遞交申請。",
        decideCompany1: "電力公司名稱",
        submitDate: "申請表提交日期為",
        submitTypeOption: {
            noLetter: "提交通知表格（不連同電力公司的批准信或拒絕信）",
            uploadLetter: "只上傳電力公司的批准或拒絕信",
            haveLetter: "提交通知表格（連同電力公司的批准信或拒絕信）",
        },
        districtOptions: {
            JOINT_OFFICE_FOR_KINDERGARTENS_AND_CHILD_CARE_CENTRES:
                "幼稚園及幼兒中心聯合辦事處",
            North: "北區",
            KWwai_Tsing: "葵青區",
            Sai_Kung: "西貢區",
            Eastern: "東區",
            Tuen_Mun: "屯門區",
            Kowloon_City: "九龍城區",
            Kwun_Tong: "觀塘區",
            Southern: "南區",
            Yau_Tsim_Mong: "油尖旺區",
            Tsuen_Wan: "荃灣區",
            Sha_Tin: "沙田區",
            Sham_Shui_Po: "深水埗區",
            Tai_Po: "大埔區",
            Wan_Chai: "灣仔區",
            Islands: "離島區",
            Central_And_Western: "中西區",
            Yuen_Long: "元朗區",
            Wong_Tai_Sin: "黄大仙區",
        },
        attachment: {
            title: "備註：",
            content: "每個文件的最大大小為1MB",
            content2: "可接受的文件類型：pdf, jpg, png, doc, docx  ",
            content3: "最大文件數：5",
        },
    },
};
export default Form072TC;
